import env from '@/env';
import createAuthorizedApiClient, { AuthTokenType } from '../authorized-api-client';

const countryInformationApisClient = createAuthorizedApiClient(
  env.api.baseUrl.countryInformation,
  AuthTokenType.AppOrUserAccessToken,
);

class Regions {
  fetchRegions = async () => {
    const response = await countryInformationApisClient.get(`regions`);
    return response.data;
  };

  fetchCurrencies = async () => {
    const response = await countryInformationApisClient.get(`currencies?pageSize=500`);
    return response.data;
  };

  fetchCountriesByRegion = async (regionName: string) => {
    const response = await countryInformationApisClient.get(
      `regions/${regionName}/countries?pageSize=500`,
    );
    return response.data;
  };
}

export const RegionsInstance = new Regions();
